import React from 'react';
import { Box, FormControlLabel, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import { IOSSwitch } from '../../component/switch/IOSSwitch';
import i18n from '../../i18n';

export type CustomerPageToolbarProps = {
    /** 智能搜索关键词（前端模糊匹配姓名、电话） */
    searchText: string;
    onSearchTextChange: (value: string) => void;
    /** 智能查重：仅展示重复项（同电话或同名的后续记录） */
    dedupEnabled: boolean;
    onDedupChange: (value: boolean) => void;
};

/**
 * 顾客资料列表顶栏：智能搜索 + 智能查重（Figma 1675:22628）
 */
export default function CustomerPageToolbar(props: CustomerPageToolbarProps) {
    const { searchText, onSearchTextChange, dedupEnabled, onDedupChange } = props;
    return (
        <Box className='customer-page-toolbar'>
            <OutlinedInput
                className='customer-page-toolbar__search'
                placeholder={i18n.t('customers_page_smart_search')}
                value={searchText}
                onChange={(e) => onSearchTextChange(e.target.value)}
                size='small'
                endAdornment={(
                    <InputAdornment position='end'>
                        <Search sx={{ color: 'var(--text-secondary)', fontSize: 24 }} aria-hidden />
                    </InputAdornment>
                )}
                inputProps={{ 'aria-label': i18n.t('customers_page_smart_search') }}
            />
            <FormControlLabel
                className='customer-page-toolbar__dedup'
                labelPlacement='start'
                control={(
                    <IOSSwitch
                        checked={dedupEnabled}
                        onChange={(_, v) => onDedupChange(v)}
                    />
                )}
                label={(
                    <Typography component='span' variant='body1' sx={{ color: 'var(--text-dark)', fontWeight: 500 }}>
                        {i18n.t('customers_page_smart_dedup')}
                    </Typography>
                )}
            />
        </Box>
    );
}
